import { Constants } from '@bingads-webui-clientcenter/entity-utils';

// select options need a string/number key, so these are used as a placeholder for null
export const UnsetPiid = 'no_pi';

export const PiTypeNames = {
  [Constants.PaymentInstrumentType.OfflinePaymentMethod]: _TL_('Bank transfer'),
  [Constants.PaymentInstrumentType.CreditCard]: _TL_('Credit or debit card'),
  [Constants.PaymentInstrumentType.PayPal]: _TL_('PayPal'),
  [Constants.PaymentInstrumentType.ELV]: _TL_('SEPA direct debit'),
  [Constants.PaymentInstrumentType.Boleto]: _TL_('Boleto Bancário'),
};

export const PiOptionNames = {
  [Constants.PaymentTypeId.Postpay]: _TL_('Postpay'),
  [Constants.PaymentTypeId.Prepay]: _TL_('Prepay'),
};

export const CouponLength = 16;

// for now, we will assume every error that isn't a coupon is a PI error
export const IsPiError = ({ FieldId }) => FieldId !== 'CouponCode';
